import { useIntl } from 'react-intl';
import { useLoggedInUser } from '../../app/hooks/useLoggedInUser';
import SideModalWrapper from '../Assets/modals/SideModalWrapper';
import { messages } from './messages';
import ServiceForm from './ServiceForm';
import { IService } from './types';

interface CreateServiceFormProps {
    isOpen: boolean;
    handleClose: () => void;
}

const CreateServiceForm = ({ isOpen, handleClose }: CreateServiceFormProps) => {
    const { formatMessage } = useIntl();
    const { tenantId } = useLoggedInUser();

    const emptyService: IService = {
        tenantId,
        name: '',
        description: '',
        code: '',
        customerSelectable: false,
        enabled: true,
        loadTypes: []
    };

    return (
        <SideModalWrapper
            open={isOpen}
            onClose={handleClose}
            headerLabel={formatMessage(messages.createEditService)}
            withBottomBox={false}
        >
            <ServiceForm
                service={emptyService}
                handleClose={handleClose}
            />
        </SideModalWrapper>
    );
};

export default CreateServiceForm;
